module.exports = __webpack_public_path__ + "img/event.2634fc53.png";